import { useEffect, useState } from "react";

const KEY = "ir_theme";
const media = window.matchMedia("(prefers-color-scheme: dark)");
let pref = localStorage.getItem(KEY) || "system";

const paint = () => {
  const dark = pref === "dark" || (pref === "system" && media.matches);
  document.documentElement.classList.toggle("app-dark", dark);
  window.dispatchEvent(new Event("theme-changed"));
};

export const theme = {
  get: () => pref,
  set(v) { pref = v || "system"; localStorage.setItem(KEY, pref); paint(); },
  on() { paint(); media.addEventListener("change", paint); },
  off() { media.removeEventListener("change", paint); document.documentElement.classList.remove("app-dark"); window.dispatchEvent(new Event("theme-changed")); },
};

export function useDarkApp() {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains("app-dark"));
  useEffect(() => {
    const h = () => setDark(document.documentElement.classList.contains("app-dark"));
    window.addEventListener("theme-changed", h);
    return () => window.removeEventListener("theme-changed", h);
  }, []);
  return dark;
}
